/* tslint:disable */
/* eslint-disable */
/**
 * Melco Eod APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EodMelcoEodModelsEodLog
 */
export interface EodMelcoEodModelsEodLog {
    /**
     * 
     * @type {number}
     * @memberof EodMelcoEodModelsEodLog
     */
    user_id?: number;
    /**
     * 
     * @type {string}
     * @memberof EodMelcoEodModelsEodLog
     */
    device_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EodMelcoEodModelsEodLog
     */
    status?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EodMelcoEodModelsEodLog
     */
    error?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EodMelcoEodModelsEodLog
     */
    error_message?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EodMelcoEodModelsEodLog
     */
    url?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof EodMelcoEodModelsEodLog
     */
    created_date?: Date | null;
}

export function EodMelcoEodModelsEodLogFromJSON(json: any): EodMelcoEodModelsEodLog {
    return EodMelcoEodModelsEodLogFromJSONTyped(json, false);
}

export function EodMelcoEodModelsEodLogFromJSONTyped(json: any, ignoreDiscriminator: boolean): EodMelcoEodModelsEodLog {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user_id': !exists(json, 'user_id') ? undefined : json['user_id'],
        'device_id': !exists(json, 'device_id') ? undefined : json['device_id'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'error': !exists(json, 'error') ? undefined : json['error'],
        'error_message': !exists(json, 'error_message') ? undefined : json['error_message'],
        'url': !exists(json, 'url') ? undefined : json['url'],
        'created_date': !exists(json, 'created_date') ? undefined : (json['created_date'] === null ? null : new Date(json['created_date'])),
    };
}

export function EodMelcoEodModelsEodLogToJSON(value?: EodMelcoEodModelsEodLog | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user_id': value.user_id,
        'device_id': value.device_id,
        'status': value.status,
        'error': value.error,
        'error_message': value.error_message,
        'url': value.url,
        'created_date': value.created_date === undefined ? undefined : (value.created_date === null ? null : value.created_date.toISOString()),
    };
}


